import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { SearchParams } from '@synergy/models';
import { createSearchByObject, mergeSearchParams } from '@synergy/utils';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { Supplier } from '../models/supplier';

export const CANCEL_REQUEST_SUPPLIERS = 'CANCEL_REQUEST_SUPPLIERS';
export const RECEIVE_SUPPLIERS = 'RECEIVE_SUPPLIERS';
export const REQUEST_SUPPLIERS = 'REQUEST_SUPPLIERS';
export const RESET_SUPPLIERS_SEARCH_PARAMS = 'RESET_SUPPLIERS_SEARCH_PARAMS';

const requestSuppliers = () => {
    return {
        type: REQUEST_SUPPLIERS,
    };
};

const receiveSuppliers = (suppliers: PaginatedResponse<Supplier>) => {
    return {
        type: RECEIVE_SUPPLIERS,
        suppliers,
    };
};

const cancelRequestSuppliers = () => {
    return {
        type: CANCEL_REQUEST_SUPPLIERS,
    };
};

export const fetchRelatedSuppliers = (searchParams: SearchParams) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const params = mergeSearchParams(getState().suppliers.searchParams, searchParams);

        dispatch(requestSuppliers());
        const response = await api.supplier.fetchRelatedSuppliers(createSearchByObject(params));

        if (response.success) {
            dispatch(receiveSuppliers(response.result));
        } else {
            dispatch(cancelRequestSuppliers());
        }
    };
};

export const resetSuppliersSearchParams = () => {
    return {
        type: RESET_SUPPLIERS_SEARCH_PARAMS,
    };
};
